import React from 'react';
import { FileUploadSection, UploadFile } from '@/components/common/admin/mobile/FileUploadSection';
import { ITaskFormValues, ITaskFile } from '@/types/admin/tasks';

interface TaskFilesSectionProps {
  formData: ITaskFormValues;
  errors: Record<string, string | undefined>;
  onFieldChange: (field: keyof ITaskFormValues, value: any) => void;
}

export const TaskFilesSection: React.FC<TaskFilesSectionProps> = ({
  formData,
  errors,
  onFieldChange,
}) => {
  const handleFilesChange = (files: UploadFile[]) => {
    onFieldChange('files', files);
  };

  // Convert ITaskFile[] to UploadFile[] for existing files
  const convertedFiles: UploadFile[] = (formData.files || []).map((file: ITaskFile | UploadFile) => {
    // If it's already an UploadFile, return as is
    if ('uri' in file && 'type' in file) {
      return file as UploadFile;
    }
    // Convert ITaskFile to UploadFile
    const taskFile = file as ITaskFile;
    return {
      id: taskFile.id.toString(),
      name: taskFile.name || taskFile.label,
      uri: taskFile.fileUrl,
      type: 'application/octet-stream', // Default type for existing files
    };
  });

  return (
    <FileUploadSection
      title="Attachments"
      subtitle="Upload files to attach to your task (optional)"
      files={convertedFiles}
      onFilesChange={handleFilesChange}
      error={errors.files}
      maxFiles={5}
      allowedTypes={['image', 'pdf', 'document', 'text', 'spreadsheet']}
    />
  );
};
